<div
  class="box alert is-paddingless"
  [class.done]="isProcessed === 'success'"
  [class.edit]="isProcessed === 'edited' || isProcessed === 'view' || isProcessed === ''"
>
  <div class="columns is-vcentered">
    <div class="column is-narrow p-1">
      <em
        *ngIf="isProcessed === 'success'"
        class="mdi mdi-alert-circle mdi-16px"
        aria-hidden="true"
      ></em>
      <em
        *ngIf="isProcessed === 'edited' || isProcessed === 'view' || isProcessed === ''"
        class="mdi mdi-alert mdi-16px"
        aria-hidden="true"
      ></em>
    </div>
    <div class="column p-1">
      <span *ngIf="isProcessed == 'edited'">{{ message + '-edit' | translate }}</span>
      <span *ngIf="isProcessed == 'success'">{{ message + '-done' | translate }}</span>
      <span *ngIf="isProcessed == 'view'">{{ message + '-view' | translate }}</span>
      <span *ngIf="isProcessed == ''">{{ message | translate }}</span>
    </div>
    <div class="column is-narrow p-1">
      <a class="is-pulled-right is-uppercase has-text-white weight-medium is-5">
        <ng-content select="[button]"></ng-content>
      </a>
    </div>
  </div>
</div>
